import { render, staticRenderFns } from "./ImageMedia.vue?vue&type=template&id=110522a2&scoped=true"
import script from "./ImageMedia.vue?vue&type=script&lang=js"
export * from "./ImageMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110522a2",
  null
  
)

export default component.exports